<template>
  <div class="order-to-be-received">
    <div v-show="this.orderList.length">
      <list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <ul class="main-order-list" >
          <li class="order-intro" v-for="(order, index) in orderList" :key="index">
            <!-- 场馆预约订单 -->
            <order-item
              v-if="order.order_type === 2"
              :order="order"
              @view-code="viewCouponCode(order, index)"
            ></order-item>
            <!-- 其他订单 -->
            <div v-else>
              <div class="order-title van-hairline--bottom">
                <div class="order-time">
                  <span class="icon"></span>
                  <span class="time">{{order.create_at}}</span>
                </div>
                <span
                  class="order-status"
                  :class="{ 'order-no-paid' : order.status === 0, 'order-finished': order.status === 400, 'order-no-bag' : order.status == 200, 'order-no-sign-for': order.status == 300 } ">
                  {{order.status_remark}}
                </span>
              </div>
              <div class="order-sku-intro">
                <sku-list :sku="order.sku_img" :id="order.trade_id" :total="order.sku_num"></sku-list>
              </div>
              <div class="order-info-intro">
                <div class="order-total-price">
                  共 {{order.sku_num}} 件商品，总计：¥{{order.count_real_pay}}
                </div>
                <!-- <div class="order-functional-btn" v-show="order.status >= 300">
                  <button
                    class="check-details"
                    @click="chekcDetails(order.trade_id)" >查看详情</button>
                  <button class="confirm-receipt" @click="confirmReceipt(order.trade_id)">确认收货</button>
                </div> -->
              </div>
            </div>
          </li>
        </ul>
      </list>
    </div>
    <div class="empty" v-show="empty && !this.orderList.length">
      <no-data />
    </div>
    <popup v-model="showQrcode.show">
      <div class="qrcode-box">
        <div class="img-box">
          <img :src="showQrcode.img" alt="">
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
import { List, Popup } from 'vant'
import SkuList from '../OrderSKuList'
import NoData from './OnData'
import OrderItem from './orderItem.vue'
let flag = false
export default {
  name: 'orderToBeReceived',
  components: {
    SkuList,
    OrderItem,
    NoData,
    Popup,
    List
  },
  data () {
    return {
      showQrcode: {
        show: false,
        img: ''
      },
      orderList: [],
      empty: false,
      pageNum: 1,
      loading: false,
      finished: false
    }
  },
  created () {
    this.$toast.loading('加载中...')
    this.getOrderList().then(() => {
      this.$toast.clear()
    })
  },
  methods: {
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getOrderList(++this.pageNum)
          .then(() => {
            this.loading = false
            flag = false
          })
      }, 1000)
    },
    async viewCouponCode (order, index) {
      this.$toast.loading('正在加载...')
      const res = await this.$axios.get(`5gadmin/customer/api/sport/qrcode?cardkey=${order.sport_order_item[0].cardkey}&size=100`)
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          // this.$connectSocket()
          this.showQrcode.img = data.qr_code
          this.showQrcode.show = true
        } else {
          this.$toast(msg)
        }
      }
      this.$toast.clear()
    },

    /**
     * 获取待收货列表
    */
    async getOrderList (pageNum) {
      const res = await this.$axios.get(`api/order/list_all/r/${pageNum || 1}`)
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.orderList = [...this.orderList, ...data]
        } else if (code === 9006) {
          if (this.pageNum === 1) {
            this.empty = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 更新视图
    */
    updateView (trade) {
      this.orderList.map(order => {
        if (order.trade_id === trade) {
          order.status = -1
          order.status_remark = '已取消'
        }
      })
    },

    /**
     * 查看详情
    */
    chekcDetails (orderid) {
      this.$router.push({ name: 'orderDetails', query: { orderid } })
    },

    /**
     * 确认收货
    */
    confirmReceipt (orderid) {

    }
  }
}
</script>

<style lang="less" scoped>
.order-intro {
  padding-bottom: 0.34rem;
  background-color: #fff;
  margin-bottom: 0.2rem;
  .order-title {
    padding: 0 0.2rem;
    height: 0.8rem;
    .flex-between;
    .order-time {
      height: 100%;
      display: flex;
      align-items: center;
      font-size: @fz28;
      color: #403232;
      .icon {
        width: 0.4rem;
        height: 0.4rem;
        background: url('../../assets/img/order-icon.png') center no-repeat;
        background-size: 100%;
        margin-right: 0.2rem;
      }
      .time {

      }
    }
    .order-status {
      font-size: @fz24;
      color: #FF9600;
    }
    .order-no-paid {
      color: #FF3824;
    }
    .order-finished {
      color: #1EA5FF;
    }
    .order-no-bag {
      color: #FF9600;
    }
    .order-no-sign-for {
      color: #FF9600;
    }
  }
  .order-sku-intro {
    padding: 0.2rem 0.2rem 0.37rem;
  }
  .order-info-intro {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .order-total-price {
    padding-right: 0.22rem;
    font-size: @fz28;
    color: @base;
    font-weight: bold;
    text-align: right;
  }
  .order-functional-btn {
    width: 3.7rem;
    .flex-between;
    justify-content: flex-end;
    padding: 0.4rem 0.22rem 0 0;
    button {
      width: 1.7rem;
      height: 0.68rem;
      border-radius: 30px;
      font-size: @fz24;
      color: @base;
    }
    .cancel-order, .check-details {
      border: 0.5px solid #979797;
      box-sizing: border-box;
      margin-right: 0.45rem;
    }
    .pay-now {
      background-color: #FF3824;
      color: #fff;
    }
    .confirm-receipt {
      background-color: #1EA5FF;
      color: #fff;
    }
  }
}
.qrcode-box{
  width: 6rem;
  height: 6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFF;
  border-radius: .2rem;
  .img-box{
    width: 4.8rem;
  }
  img{
    width: 100%;
  }
}
</style>
<style lang="less">
.ordervant{
  .van-popup{
    background: none;
  }
}
</style>
